import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import { selectUser } from "store/user/selectors";
import { setUser } from "store/user";
import InputField from "components/FormFields/InputField";

export default function StartForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  function handleInputChange(e) {
    dispatch(setUser({ username: e.target.value }));
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        navigate("/setup");
      }}
    >
      {user.id == null && (
        <InputField
          id="guestPlayerName"
          name="name"
          type="text"
          required
          placeholder="Adınızı daxil edin"
          label="Adınız"
          value={user.username}
          onChange={handleInputChange}
        />
      )}
      <Button className="w-full mt-3">Başla</Button>
    </form>
  );
}
